import React from 'react';
import { Link, useLocation } from "react-router-dom";

const SubmitResult = () => {
    const location = useLocation();
    
    // Retrieve the answers object passed from the previous page
    const answersObject = location.state?.answers || {};

    // Convert the object back to a Map
    const answerMap = new Map(Object.entries(answersObject));

    let totalQuestions = answerMap.size;
    let correctCount = 0;
    let incorrectAnswers = new Map();

    // Calculate the total correct answers
    answerMap.forEach(({ userAnswers, correctAnswers }, questionNumber) => {
        const isCorrect = Array.isArray(correctAnswers)
            ? Array.isArray(userAnswers) && userAnswers.sort().join(",") === correctAnswers.sort().join(",")
            : userAnswers === correctAnswers;

        if (isCorrect) {
            correctCount++;
        } else {
            incorrectAnswers.set(questionNumber, { userAnswers, correctAnswers });
        }
    });

    return (
        <div className="w-full min-h-screen flex flex-col bg-gray-50">
            {/* Navigator Bar */}
            <div className="w-full h-[50px] bg-white flex items-center px-4 border-b border-gray-300">
                <div className="flex items-center justify-center h-full bg-gray-200 rounded-md px-4">
                    <Link to={"/student-dashboard"}><span className="text-sm text-gray-700">IELTS Virtual Exam</span></Link>
                </div>
            </div>

            {/* Main Content */}
            <div className="w-full flex-1 flex flex-col justify-center items-center px-10 py-5">
                <div className="w-full max-w-[533px] bg-white rounded-lg shadow-lg p-6 font-sans border border-gray-300">
                    {/* Result Section */}
                    <div className="w-full bg-gray-100 rounded-lg p-6 my-4">
                        <div className="text-xl font-semibold text-gray-800">Your Result</div>
                        <div className="mt-4 text-gray-600">
                            <p>Your answer has been submitted successfully.</p>
                            <p className="mt-2">Total Questions: <b>{totalQuestions}</b></p>
                            <p className="mt-2">Correct Answers: <b>{correctCount}</b></p>
                            <p className="mt-2 text-red-500">Wrong Answers: <b>{incorrectAnswers.size}</b></p>
                        </div>
                    </div>

                    {/* Incorrect Answers List */}
                    {incorrectAnswers.size > 0 && (
                        <div className="w-full bg-red-100 rounded-lg p-4 my-4">
                            <div className="text-lg font-semibold text-red-600">Incorrect Answers</div>
                            <ul className="mt-2 text-gray-700">
                                {[...incorrectAnswers].map(([questionNumber, { userAnswers, correctAnswers }]) => (
                                    <li key={questionNumber} className="mt-1">
                                        Question {questionNumber}: Your Answer: <b>{Array.isArray(userAnswers) ? userAnswers.join(", ") : userAnswers}</b>, 
                                        Correct Answer: <b>{Array.isArray(correctAnswers) ? correctAnswers.join(", ") : correctAnswers}</b>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default SubmitResult;
